import { FC, FunctionComponent } from 'react';

import { default as WizardStep, WizardStepProps } from './WizardStep';
import { default as WizardWrapper, WizardWrapperProps } from './WizardWrapper';

type WizardType = FunctionComponent & {
  Wrapper: FC<WizardWrapperProps>;
  Step: FC<WizardStepProps>;
};

const Wizard: WizardType = ({ children }): JSX.Element => <>{children}</>;

Wizard.Wrapper = WizardWrapper;
Wizard.Step = WizardStep;

export default Wizard;
